

























































































import { Component, Vue, Watch } from "vue-property-decorator";
import { Overlay as vanOverlay, Loading as vanLoading, Toast } from "vant";
import "@/common/animate.min.css";
import request from "@/api/index";
import requestNewchongqing from "@/api/newchongqing";
import Base from "@/template/public/Base.vue";
import native from "@/common/Native";
import { wxChatShare, wxChatJumpApp } from "@/common/wechat";
import AppPrompt from "@/components/AppPrompt.vue";
import VConsole from "vconsole";
import { dateFormat } from "@/common/Utils";
import nopage from "@/components/404.vue";
import ImageViewComMu from "@/components/imageViewComMu.vue";
import Poster from "@/components/Poster.vue";
import vertical from "@/components/multiple/VerticalWZ.vue";
import novertical from "@/components/multiple/noVertical.vue";
import moreList from "@/components/multiple/moreList.vue";
import { getData, time } from "@/common/dataCollect";
interface IShareInfo {
  /** 顶图	 */
  shareBg: string;
  /** 分享图标	 */
  shareLogo: string;
  /** 客户端名字	 */
  appName: string;
  /** 客户端下载地址	 */
  downloadUrl: string;
  /** 底图 */
  shareClose: string;
  /** scheme */
  schemeUrl: string;
}
interface IResponse {
  code: number;
  message: string;
  sessionId: string;
  data: IShareInfo;
}

@Component({
  components: {
    AppPrompt,
    vanOverlay,
    vanLoading,
    nopage,
    ImageViewComMu,
    Poster,
    vertical,
    novertical,
    moreList
  }
})
export default class NewsMultiple extends Base {
  private isShowCover: boolean = false;
  private pictureHeight: string | any = "";

  private imgList: Array<object> = [];
  private imgInfo: object | any = {};
  private isOpenApp: boolean = false;
  private id: string | any = "";
  private isPlay: boolean = false;
  private newsId: string = "";
  private appStauts: number = 0;

  public request = new request();
  private vfrom: string = "";
  private clickIndex: number = 0;
  private userInfo: any = {
    appId: "",
    sessionId: "",
    token: "",
    nickName: ""
  };
  public appId: string = "";
  private businessDetail: any = {
    isPraised: "",
    viewCount: "",
    praiseCount: "",
    replyCount: ""
  };
  private isYbp: string = "0";

  isNewOpenApp = false; //是否显示微信唤醒的按钮
  extinfo: any = "";
  private posterTitle: string = "";
  private requestLoaded: boolean = false;

  //多图重构参数
  private imgListAcross: Array<object> = [];
  isShowVertical = true; // 是否手机横着  false就是横着  true是竖着
  isAcrossWidth: any = 0; // 横着的手机宽度  竖着的手机高度
  isAcrossHeight: any; // 横着的手机高度  竖着的手机宽度
  i: any = 0; // 默认第一张
  currentIndex = 0; //
  isApp = false;
  imgMoreList = []; // 推荐更多列表
  showMore = false; // 是否显示推荐更多
  isShowLast = true;
  // 埋点
  startTime: string = "";
  endTime: string = "";
  dataSource = true;
  openhdstatic: any = false; // 是否显示头部唤醒 - 最高优先级  1显示  2不显示
  created() {
    this.startTime = time();
  }
  async mounted(): Promise<void> {
    (this.$route.query.openhdstatic as string) == "2"
      ? (this.openhdstatic = false)
      : (this.openhdstatic = true);
    this.vfrom = this.$route.query.vfrom as string;
    this.appId = (this.$route.query.appId as string) || "";
    this.isYbp = this.$route.query.isYbp as string; // 是否是在阅报屏中打开的 （在阅报屏中打开即是不在端内，但是不能显示app头部提示）
    this.isOpenApp = ZWY_CLOUD.isOpenInApp();
    this.id = this.$route.query.id as string;
    this.renderResize();
    if (!this.isOpenApp) {
      window.addEventListener("resize", this.renderResize, false);
    }
    this.getImgList();
    this.getCount();

    if (ZWY_CLOUD.isOpenInApp()) {
      // get用户信息
      native.getUserInfo().then((response: any) => {
        this.userInfo = response;
        this.getBussinessDetail();
      });
    } else {
      this.getBussinessDetail();
    }
    if (this.isOpenApp) {
      //app内就走app的监听
      let that = this;
      (window as any).appResizeStauts = function appResizeStauts(
        stauts: number
      ) {
        if (stauts == 1 || stauts == 3) {
          that.isShowVertical = false;
        } else {
          that.isShowVertical = true;
        }
        that.currentIndex = that.i;
      };
    } else {
      //app外监听事件
      this.renderResize();
      window.addEventListener("resize", this.renderResize, false);
    }
  }

  // 横竖屏监听
  renderResize() {
    let width = document.documentElement.clientWidth;
    let height = document.documentElement.clientHeight;
    if (width > height) {
      //横
      this.isShowVertical = false;
      this.isAcrossHeight = document.body.clientHeight;
      this.isAcrossWidth = document.body.clientWidth;
    } else {
      //竖
      this.isShowVertical = true;
      this.isAcrossHeight = document.body.clientWidth;
      this.isAcrossWidth = document.body.clientHeight;
    }
    this.currentIndex = this.i;
  }
  // 获取多图列表
  getImgList() {
    return this.request
      .getList(this.id)
      .then(res => {
        if (res.code === 0) {
          // console.log(res.data);
          this.imgInfo = res.data;
          this.posterTitle =
            this.imgInfo.title.length > 26
              ? this.imgInfo.title.slice(0, 26) + "..."
              : this.imgInfo.title;
          if (this.imgInfo.audioUrl) {
            this.isPlay = true;
          } else {
            this.isPlay = false;
          }
          document.title = this.imgInfo.richTitle || this.imgInfo.title;
          this.imgList = this.imgInfo.appResource;
          let imgListCopy = [...this.imgList];
          this.imgListAcross = imgListCopy.reverse();
          this.appId = this.imgInfo.appId;
          this.$store.commit("SET_STATE", {
            appId: this.appId
          });
          this.infoClassifyId = this.imgInfo.infoClassifyId;
          // 推荐获取
          this.getMoreImgList(this.imgInfo.infoClassifyId);
          // 分享信息获取
          this.getBaseappInfoConfigList(this.imgInfo.appId);
          this.detailGetAppId = this.imgInfo.appId;

          let params = {
            contextType: this.imgInfo.contextType, // contextType 竖版视频传5  多图新闻传1 其他的也传1
            detailViewType: "2", // 写死传2
            id: this.imgInfo.infoClassifyId, //新闻id
            videoFormat: "-1", //  videoFormat竖屏新闻传2  别的为-1
            shareUrl: window.location.href, //新闻url
            url: window.location.href, // 新闻url
            sourceId: this.imgInfo.infoClassifyId, // sourceId
            sourceType: "", // sourceType空字符串
            thirdUrlEncode: false,
            title: "", // title空字符串
            shareTitle: "" // shareTitle空字符串
          };
          console.log(params);
          this.extinfo = JSON.stringify(params);
          const el = this.$refs.ImageViewCom as any;
          el.openView(0);

          this.$nextTick(() => {
            // 埋点
            this.endTime = time();
            if (this.dataSource) {
              getData(this.startTime, this.endTime, this.imgInfo);
              this.dataSource = false;
            }
          });
        }
      })
      .finally(() => {
        this.requestLoaded = true;
      });
  }
  //多图推荐
  getMoreImgList(infoClassifyId: any) {
    return this.request
      .getImgMore(infoClassifyId)
      .then(res => {
        if (res.code === 0) {
          let data = res.data;
          this.imgMoreList = data.dataList;
          if (this.imgMoreList) {
            this.showMore = true;
          } else {
            this.showMore = false;
          }
        } else {
          this.showMore = false;
        }
      })
      .catch(() => {
        this.showMore = false;
      });
  }

  /**业务详情 */
  getBussinessDetail() {
    this.request
      .getBussinessDetail(
        this.appId,
        this.userInfo.sessionId,
        // this.newsInfo.informationId,
        this.id,
        "1",
        this.userInfo.token
      )
      .then((response: any) => {
        if (response.code >= 0) {
          this.businessDetail = response.data;
          wxChatShare(
            response.data.detailTitle,
            response.data.shareDescription,
            response.data.shareUrlWx,
            response.data.shareImgUrl
          );
        }
      });
  }
  // 浏览量
  getCount() {
    if (!native.isOpenInApp()) {
      // 在app外才需要增加浏览量
      this.request.getCount(this.appId, this.id);
    }
  }

  // wx标签初始化完毕，可以进行点击操作
  handleReadyFn(e: any) {
    console.log("初始化成功", e);
  }
  // wx标签用户点击跳转按钮并对确认弹窗进行操作后触发
  handleLaunchFn(e: any) {
    console.log("success", e);
    console.log("mu222");
  }
  // wx标签用户点击跳转按钮后出现错误
  handleErrorFn(e: any) {
    console.log("fail", e.detail);
    console.log(e);
    console.log("如果是没安装应用, 则跳转下载页");
    (this.$refs.newopenapp as any).handleErrorFn();
  }
  // 统一横竖屏切换的index
  // 竖版
  getCurrentIndexV(data: any) {
    // data是当前的index
    console.log("huoquV" + data);
    this.i = data;
    const el = this.$refs.ImageViewCom as any;
    el.openView(data);
    // if (data == this.imgList.length && this.showMore) {
    //   this.isShowLast = false;
    // } else {
    //   this.isShowLast = true;
    // }
  }
  //横版
  getCurrentIndexH(data: any) {
    // data是当前的index
    console.log("huoquH" + data);
    this.i = data;
    // if (data == this.imgList.length && this.showMore) {
    //   this.isShowLast = false;
    // } else {
    //   this.isShowLast = true;
    // }
  }
}
